import * as React from "react";
import { DeckComponent } from "./DeckComponent";
import { IActState } from "./Scenario";
import { GameToken } from "./Card";

export interface IActDeckProps {
    state: IActState;
    onChanged: () => void;
}
export class ActDeckComponent extends React.Component<IActDeckProps, any> {
    render() {
        return (
            <div id="actDeck">
                <DeckComponent deck={this.props.state.deck} horizontal={true}
                    settings={{ toolbar: { navigation: true, navigationAllowedOnFaceDownCards: true, align:"right" }, allowedTokens: [GameToken.Clue], hideTokensOnBack: true }}
                    onChanged={() => this.props.onChanged()} />
            </div>
        );
    }
}
